import { NgModule } from '@angular/core';
import { AngularCountdownDateTimeComponent } from './angular-countdown-date-time.component';

@NgModule({
  declarations: [AngularCountdownDateTimeComponent],
  imports: [
  ],
  exports: [AngularCountdownDateTimeComponent]
})
export class AngularCountdownDateTimeModule { }
